import { useParams } from 'react-router-dom';
import AuthorHeader from './components/AuthorHeader';
import AuthorBio from './components/AuthorBio';
import AuthorPosts from './components/AuthorPosts';

export default function AuthorPage() {
  const { authorSlug } = useParams();

  return (
    <div className="min-h-screen bg-[#F5F7FA]">
      {/* Header */}
      <AuthorHeader />

      {/* Main content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-8">
        {/* Author Bio - full width on mobile, centered on larger screens */}
        <div className="mb-6 sm:mb-8 w-full">
          <AuthorBio authorSlug={authorSlug} />
        </div>
        
        {/* Author Posts */}
        <div className="w-full">
          <AuthorPosts authorSlug={authorSlug} />
        </div>
      </div>
    </div>
  );
}
